import React, { memo } from 'react'

import Title from 'components/CommonUI/Title/Title'
import SearchInput from 'components/CommonUI/SearchInput/SearchInput'

const AlertsHeader = ({ searchValue, handleChange }) => {
  return (
    <div className="alerts_page_header">
      <Title title="Alerts" component="h1" />
      <SearchInput
        placeholder={'Search alert by keyword'}
        classNameContainer="alerts_search"
        value={searchValue}
        handleChange={handleChange}
      />
    </div>
  )
}

export default memo(AlertsHeader)
